import {
  ArmchairIcon,
  CarProfileIcon,
  CloudRainIcon,
  DropIcon,
  GaugeIcon,
  HeadlightsIcon,
  ShieldCheckIcon,
  SparkleIcon,
  TireIcon,
  WrenchIcon,
  type Icon,
} from '@phosphor-icons/react';

/**
 * Visual marker of a service, picked from its category and name (no extra data in
 * business.json). Order matters: "Полировка фар" is about headlights, not the body.
 */
const RULES: Array<[RegExp, Icon]> = [
  [/фар|оптик/i, HeadlightsIcon],
  [/шин|колёс|колес|диск|развал|балансир/i, TireIcon],
  [/мойк|мыть|wash/i, DropIcon],
  [/салон|химчист|кож|интерьер/i, ArmchairIcon],
  [/керам|плёнк|пленк|защит|ppf/i, ShieldCheckIcon],
  [/полир|кузов/i, SparkleIcon],
  [/стёкл|стекл|антидожд/i, CloudRainIcon],
  [/диагност/i, GaugeIcon],
  [/масл|колод|тормоз|обслуж|ремонт/i, WrenchIcon],
];

export function serviceIcon(service: { name: string; category?: string | null }): Icon {
  const text = `${service.name} ${service.category ?? ''}`;
  for (const [pattern, icon] of RULES) if (pattern.test(text)) return icon;
  return CarProfileIcon;
}
